const modalVideo = () => {
    const modalEl = document.getElementById('videoModal');
    const videoFrame = document.getElementById('videoFrame');

    if ( !videoFrame) return;

    // const modal = new Modal(modalEl);
    const btns = document.querySelectorAll('.modal-btn .wp-block-button__link');
    btns.forEach((btn) => {
        btn.setAttribute('type', 'button');
        btn.setAttribute('data-bs-toggle', 'modal');
        btn.setAttribute('data-bs-target', '#videoModal');

        btn.addEventListener('click', function (e) {
        //     e.preventDefault();

            const videoUrl = this.dataset.url;
            const embedUrl = getYouTubeEmbedUrl(videoUrl);

            if (embedUrl) {
                videoFrame.src = embedUrl + '?autoplay=1&mute=1';
                // modal.show();
            }
        });
    });

    // Stop video when modal closes
    modalEl.addEventListener('hidden.bs.modal', function () {
        videoFrame.src = '';
    });
};
export default modalVideo;

/**
 * Convert YouTube URL into privacy-enhanced embed format
 *
 * @param {string} url
 * @returns {string|null} embed url
 */
const getYouTubeEmbedUrl = url => {
    try {
        const parsedUrl = new URL(url);

        // Case 1: youtu.be short link
        if (parsedUrl.hostname.includes('youtu.be')) {
            const videoId = parsedUrl.pathname.replace('/', '');
            return `https://www.youtube-nocookie.com/embed/${videoId}`;
        }

        // Case 2: youtube.com/watch?v=VIDEO_ID
        if (parsedUrl.hostname.includes('youtube.com')) {
            const videoId = parsedUrl.searchParams.get('v');
            if (videoId) {
                return `https://www.youtube-nocookie.com/embed/${videoId}`;
            }
        }

        return null;
    } catch (err) {
        return null;
    }
};